import { useContext } from 'react';
import { BlueprintListContext } from './BlueprintListContext';

export const useBlueprintListContext = () => useContext(BlueprintListContext);
